import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";

export function AppLayout() {
	return (
		<div className="min-h-screen bg-surface">
			<Sidebar />
			<main className="pb-24 md:pb-0 md:pt-8 md:pl-[320px] md:pr-8 min-h-screen">
				<Outlet />
			</main>
			<MobileNav />
		</div>
	);
}

function MobileNav() {
	const location = useLocation();

	const navItems = [
		{ to: "/", icon: "dashboard", label: "Home" },
		{ to: "/ratings", icon: "history", label: "Log" },
		{
			to: "/ratings/new",
			icon: "add_circle",
			label: "Rate",
			isAction: true,
		},
		{ to: "/profile", icon: "person", label: "Profile" },
	];

	return (
		<div className="md:hidden fixed bottom-0 left-0 w-full bg-surface-container-lowest border-t-4 border-brand-black flex items-center h-20 z-40">
			{navItems.map((item, index) => {
				const isActive =
					item.to === "/"
						? location.pathname === "/"
						: location.pathname.startsWith(item.to);
				const isLast = index === navItems.length - 1;

				return (
					<NavLink
						key={item.to}
						to={item.to}
						className={`flex-1 h-full flex flex-col items-center justify-center gap-1 border-r-2 border-brand-black ${isLast ? "border-r-0" : ""} ${isActive ? "bg-surface-container-high" : ""} ${item.isAction ? "bg-brand-green" : ""}`}
					>
						<span
							className={`material-symbols-outlined text-[24px] ${
								isActive ? "text-brand-blue" : "text-brand-black"
							}`}
							style={{
								fontVariationSettings: `'FILL' ${isActive ? 1 : 0}`,
							}}
						>
							{item.icon}
						</span>
						<span
							className={`font-[Space_Grotesk] text-[10px] font-bold uppercase ${
								isActive ? "text-brand-blue" : "text-brand-black"
							}`}
						>
							{item.label}
						</span>
					</NavLink>
				);
			})}
		</div>
	);
}
